/*
summary = [
	{title: 'title', link: '#example-course'},
	{title: 'My title', link: '#link-1'},
	{title: 'title 2', link: '#link2'},
];*/

export default {
	name: 'LessonSummary',
	props: {
		summary: {type: Array, default: () => ([
			{label: "Step 1", title: 'Identify', link: '#step-1'},
			{label: "Step 2", title: 'Step 2: Strategize', link: '#step-2'},
			{label: "Step 3", title: 'Step 2: Set up', link: '#step-3'},
			{label: "Step 4", title: 'Step 4: Provide a solution', link: '#step-4'},
			{label: "Step 5", title: 'Step 5: Check your work', link: '#step-5', children: []},
			{label: "Example 1", title: 'Examples', link: '#example-course'}
		])},
		deep: {default: 0}
	},
	data() {
		return {}
	},
	methods: {
		scrollToLink(link) {
			return {el: link, duration: 300, offset: -60, easing: 'ease', lazy: false }
		},
		titleWithLabel(text) {
			if (typeof text == 'object') {
				return text;
			}
			if (title.includes(':') && !title.trim().slice(-1) == ':') {
				let parts = text.split(':'), lbl = '', title = title;
				if (parts.length > 1) {
					lbl = parts[0];
					title = parts.slice(1).join(':');
				}
				return {label: lbl, title: title}
			}
		}
	},
	computed: {
		summaryWithLabels() {
			return this.summary.map(item => ({...item, title: this.titleWithLabel(item.title)}));
		}
	}
}